import { lazy } from 'react'

export const ActivityLevelV1 = lazy(() => import('./v1/ActivityLevelV1'))
export const ActivityLevelV2 = lazy(() => import('./v2/ActivityLevelV2'))
